<template>
	<div class="subject-list" ref="subjectPage">
		<el-table :data="subjectList" stripe class="subject-table" :height="tableHeight">
			<el-table-column label="题号" align="center" width="120">
				<template slot-scope="scope">
					{{ (scope.row.sort + 1).toString().padStart(2, "0") }}
				</template>
			</el-table-column>
			<el-table-column label="题目类型" align="center">
				<template slot-scope="scope">
					{{ getProblemTypeText(scope.row.problem_type) }}
				</template>
			</el-table-column>
			<el-table-column prop="problem_name" label="题目名称" align="center"></el-table-column>
			<el-table-column label="正确率" align="center">
				<template slot-scope="scope">
					<div class="rolling-groove">
						<p class="welt" :style="{width: scope.row.pass_rate + '%'}"></p>
						<p class="percentage">{{(scope.row.pass_rate).toFixed(2)}}%</p>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="" align="center" width="240">
				<template slot-scope="scope">
					<div class="show-subject" @click="showSubjectInfo(scope.row)">查看</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	import {
		getExamGroundProblemFinish
	} from '@/api/simulationGame'
	export default {
		name: "subjectList",
		components: {},
		props: {
			examGroundId: String
		},
		data() {
			return {
				tableHeight: 400,
				subjectList: []
			}
		},
		created() {
			this.getExamGroundProblemFinish();
		},
		mounted() {
			this.setTableHeight();
		},
		watch: {},
		methods: {
			setTableHeight() {
				this.$nextTick(() => {
					const divHeight = this.$refs.subjectPage.offsetHeight;
					this.tableHeight = divHeight - 40
				});
			},
			async getExamGroundProblemFinish() {
				let res = await getExamGroundProblemFinish({
					examGroundId: this.examGroundId
				});
				if (res.status) {
					this.subjectList = res.data.problem_list;
				}
			},
			getProblemTypeText(problemType) {
				const problemTypeMap = {
					1: '算法题',
					2: '编程世界',
					4: 'AI题',
					10: '选择题'
				}
				return problemTypeMap[problemType] || '未知题型'
			},
			showSubjectInfo(subjectInfo){ // 查看题目
				this.$router.push({
					name: "competition",
					query: {
						examGroundId: this.examGroundId, // 试卷ID
						type: 1,
						subjectId: subjectInfo.id // 题目ID
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.subject-list {
		height: calc(100% - 1.6rem);
		padding: 0.8rem 2.12rem;

		.rolling-groove {
			background-color: #15212A;
			width: 8rem;
			height: 1.2rem;
			margin: 0 auto;
			position: relative;

			.welt {
				background-color: #36FFF8;
				width: 60%;
				height: 100%;
				position: absolute;
			}

			.percentage {
				width: 100%;
				height: 100%;
				font-size: 0.9rem;
				color: #2470A8;
				text-align: center;
				position: absolute;
				z-index: 8;
			}
		}

		.show-subject {
			background-image: url(~@/assets/img/preliminaryClassic/join.png);
			background-size: 100%;
			background-repeat: no-repeat;
			width: 7.6rem;
			height: 2.08rem;
			margin: 0 auto;
			font-size: 1rem;
			cursor: pointer;
			line-height: 2.08rem;
		}

		::v-deep.el-table.subject-table {
			display: flex;
			flex-direction: column;
			background: none;

			.el-table__header-wrapper .el-table__header {

				tr,
				.el-table__cell {
					background-color: #184155;
				}

				tr th {
					font-family: Source Han Sans SC;
					font-weight: 500;
					font-size: 1.28rem;
					color: #81FEFF;

					.cell {
						line-height: initial;
					}
				}
			}

			.el-table__body-wrapper {
				flex: 1;
				border: 2px solid #6B9EA4;
				position: relative;
				box-sizing: border-box;

				tr td {
					font-family: Source Han Sans SC;
					font-weight: 500;
					font-size: 1.2rem;
					padding: 0;
					height: 2.8rem;

					.cell {
						line-height: initial;
					}
				}

				th.el-table__cell,
				tr,
				.el-table__empty-block {
					background-color: rgba(54, 93, 127, 1);
				}

				tr.el-table__row--striped td.el-table__cell {
					background-color: rgba(28, 55, 73, 1);
				}
			}
		}

		::v-deep.el-table--striped {
			tr.el-table__row--striped:hover td.el-table__cell {
				background-color: #69BBC4 !important;
			}
		}
	}
</style>
